module.exports = __webpack_public_path__ + "static/img/banner3@3x.6fb2376.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/banner3@3x.png
// module id = pmEz
// module chunks = 1